import React from "react";
import { useTranslation } from "react-i18next";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { formatSize } from "../../../../../config/global";
import { getFileIcon } from "../../../../../config/media";

const ProgressBarModal = ({ progressItems }) => {
  const { t } = useTranslation();
  return (
    <div className="fixed bottom-0 right-0 m-4 z-[50]">
      <div className="bg-white p-4 rounded-md shadow-md w-[400px]">
        <div className="flex justify-between items-center mb-2">
          <div className="text-lg font-bold">{t('media.media_upload_progress_title')}</div>
        </div>

        <div
          className="scroll_div pp-upload-progress-list"
          style={{ maxHeight: '50vh', overflowY: 'auto' }}
        >
          {progressItems.map(({ file, progress, status, index }) => (
            <div key={index} className="flex items-center justify-between py-1 px-4 bg-white shadow-md rounded-lg my-3">
              <div className="flex items-center gap-3 w-[70%]">
                <div className="text-2xl text-gray-400">
                  {getFileIcon(file.type)}
                </div>
                <div>
                  <p className="text-gray-900 text-sm truncate">{file.name}</p>
                  <div className="flex items-center mt-1">
                    <span className={`px-2 py-1 text-xs rounded mr-2 ${
                      status === "processing" ? "bg-blue-500" :
                        status === "success" ? "bg-green-500" :
                          "bg-red-500"
                      } text-white`}>
                      {status === "processing" ? t('media.media_status_processing') : status === "success" ? t('media.media_status_success') : t('media.media_status_failed')}
                    </span>
                    <span className="bg-gray-200 text-gray-700 px-2 py-1 text-xs rounded">
                      {formatSize(file.size)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="w-12">
                <CircularProgressbarWithChildren
                  value={status === "failed" ? 0 : progress}
                  styles={buildStyles({
                    pathColor: status === "failed" ? "#dc3545" :
                      status === "success" ? "#28a745" : "#3e98c7",
                    trailColor: "#d6d6d6",
                  })}
                >
                  <div className="text-xs text-gray-600">
                    {status !== "failed" ? `${progress}%` : "X"}
                  </div>
                </CircularProgressbarWithChildren>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressBarModal;
